<template>
    <div>
        <div style="padding: 2px 10px; background: #f3f3f3; display: inline-block; border-radius: 3px;">
            <status-dot :value="statusData.colour" style="display: inline-block; margin-right: .5rem;"></status-dot>
            <span style="text-transform: uppercase; font-size: 14px; font-weight: bold;">{{ statusData.label }}</span>
            <ui-tooltip>{{ statusData.note }}</ui-tooltip>
        </div>
    </div>
</template>

<script>
import {FundingStatuses} from "../../../classes/Api/Funding";
import StatusDot from "../../ads/StatusDot";

export default {
    components: {StatusDot},
    props: {
        record: {
            type: Object,
            required: true
        }
    },
    computed: {
        status() {
            return this.record.funding_status
        },
        statusData() {
            let data;

            switch(this.status)
            {
                case null:
                    return {
                        colour: null,
                        label: 'Sending',
                        note: 'Waiting to be sent to APAK'
                    }
                case FundingStatuses.PENDING:
                    return {
                        colour: null,
                        label: 'Pending',
                        note: 'Processing with APAK data provider'
                    }
                case FundingStatuses.VALIDATING:
                    return {
                        colour: null,
                        label: 'Validating',
                        note: 'Processing with APAK data provider'
                    }
                case FundingStatuses.PROCESSING:
                    return {
                        colour: null,
                        label: 'Processing',
                        note: 'APAK are processing the request'
                    }
                case FundingStatuses.FAILED:
                    return {
                        colour: 'red',
                        label: 'Failed',
                        note: 'Validation with the APAK data provider failed'
                    }
                case FundingStatuses.QUERIED:
                    return {
                        colour: 'orange',
                        label: 'Queried',
                        note: 'There was a minor validation error with the APAK data provider, the record was still sent for financing.'
                    }
                case FundingStatuses.WITHHELD:
                    return {
                        colour: 'red',
                        label: 'Withheld',
                        note: 'APAK refused to fund this vehicle'
                    }
                case FundingStatuses.ERROR:
                    return {
                        colour: 'red',
                        label: 'Error',
                        note: 'There was a problem funding this vehicle, contact DealerKit support.'
                    }
                case FundingStatuses.LIVE:
                    return {
                        colour: 'green',
                        label: 'Funded',
                        note: 'The vehicle was funded'
                    }
                case FundingStatuses.SETTLED:
                    return {
                        colour: 'green',
                        label: 'Settled',
                        note: 'The vehicle was settled'
                    }
                case FundingStatuses.PENDING_REMOVAL:
                    return {
                        colour: null,
                        label: 'Removing',
                        note: 'Awaiting confirmation of removal from APAK'
                    }
            }
        }
    }
}
</script>

<style scoped>

</style>